window.swag.prefetchActions = [];
export let dispatch = action => window.swag.prefetchActions.push(action);
export const replaceDispatcher = newDispatcher => dispatch = newDispatcher;